import { render } from "./AppointmentDetails.vue?vue&type=template&id=d727be02"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"

import "./AppointmentDetails.vue?vue&type=style&index=0&id=d727be02&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__